import { useState, useEffect, useRef } from "react"
import { useDispatch } from "react-redux"

import { Modal, message } from "antd"
import ReCAPTCHA from "react-google-recaptcha"
import { useRequestSupportMutation } from "./supportApiSlice"
import { showSpinner, hideSpinner } from "../../components/componentSlice"

import './SupportRequestForm.css'


const SupportRequestForm = ({ isModalOpen, onClose }) => {
    const dispatch = useDispatch()

    const [subject, setSubject] = useState(null)
    const [email, setEmail] = useState(null)
    const [captchaToken, setCaptchaToken] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)

    const captchaRef = useRef(null);

    const [ requestSupport,  {
        isLoading,
        isSuccess
    }] = useRequestSupportMutation()

    useEffect(() => {
        if(isLoading) {
            dispatch(showSpinner())
        } else{
            dispatch(hideSpinner())
        }
    }, [isLoading])

    useEffect(() => {
        if(isSuccess) {
            alertMessage("Request Submitted!")
        }
    }, [isSuccess])

    const [messageApi, contextHolder] = message.useMessage()
    
    const alertMessage = (message) => {
        messageApi.success(message)
    }

    const onSubmit = async (e) => {
        e.preventDefault();

        setErrorMessage(null)

        if (!captchaToken) {
            setErrorMessage("Please complete the CAPTCHA.")
            return
        }

        if(!subject || !email) {
            return
        }

        try {
            let request = {
                subject, 
                email, 
                captcha: captchaToken}

            await requestSupport(request).unwrap()
            resetForm()
        } catch(err) {
            setErrorMessage(err.data?.message)
        }
    }

    const resetForm = () => {
        setSubject("")
        setEmail("")
        captchaRef.current.reset()
    }

    return (
        <Modal open={isModalOpen} onCancel={() => onClose()} footer={[]}>
            <div className="support-form-content">
                <div className="support-form-header">
                    <h2>Request Support</h2>
                    <p>Please fill up the form and submit. The request will be sent to an admin.</p>
                </div>
                <p className='errorMessage'>{errorMessage}</p>
                <form onSubmit={(e) => onSubmit(e)}>
                    {contextHolder}
                    <div className="form-group">
                        <label for="subject">Subject</label>
                        <input className="inpt" type="subject" id="subject" name="subject" required  value={subject} onChange={(e) => setSubject(e.target.value)} />
                    </div>

                    <div className="form-group">
                        <label for="email">Email Address</label>
                        <input className="inpt" type="email" id="email" name="email" required  value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>

                    <div className="captcha">
                        <ReCAPTCHA
                            sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                            onChange={(token) => setCaptchaToken(token)}
                            ref={captchaRef}
                        />
                    </div>

                    <div className="form-group">
                        <button className="crm-button">Submit</button>
                    </div>
                </form>
            </div>
        </Modal>
    )
}

export default SupportRequestForm